<div class="modal-body">
    <figure>
        <img src="../../../../assets/images/tick_icon.gif" alt="git icon" />
    </figure>
    <p class="ft-wt">Congratulations!</p>
    <p>Your application has been successfully submitted</p>
    <div class="col-md-12 col-lg-12 col-sm-12">
        <a class="commonBtn" (click)="exploreMoreJobs()">Explore more Jobs</a>
    </div>
</div>